function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_3868",
  "data-name": "Rectangle 3868",
  width: 30,
  height: 30,
  rx: 15,
  fill: "#c8c8c8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_2633",
  "data-name": "Path 2633",
  d: "M1106.291,78.742c-.186-.152-1.884-2.022-2.848-2.893V71.813A1.822,1.822,0,0,0,1101.624,70h-5.937A1.691,1.691,0,0,0,1094,71.686v9.446a1.815,1.815,0,0,0,1.818,1.813h2.158a.135.135,0,0,0,.131-.139l-.1-.8a.12.12,0,0,0-.12-.111h-.263a.134.134,0,0,1-.132-.127V71.035a.134.134,0,0,1,.132-.127h4.009a.736.736,0,0,1,.734.737v9.63a.612.612,0,0,1-.449.589h0a4.175,4.175,0,0,1-1.041-1.412c0-.012-.011-.029-.011-.041-.022-.258-.318-2.754-1.643-2.754a.869.869,0,0,0-.109,0s-1.074.09-.186,3.123v.02l.394,3.36v.016a7.61,7.61,0,0,0,1.621,3.057.217.217,0,0,1,.033.086v.291c0,.008-.011.012-.022.012h-.1a.45.45,0,0,0-.449.454v1.183a.45.45,0,0,0,.449.454h4.82a.45.45,0,0,0,.449-.454V88.089a.45.45,0,0,0-.449-.454c-.011,0-.011,0-.011-.012.153-1.482.734-6.548,1.041-6.945,0-.012.011-.025.022-.041A1.883,1.883,0,0,0,1106.291,78.742Zm-10.4,3.032a.115.115,0,0,1-.11.115.732.732,0,0,1-.734-.729V71.637a.732.732,0,0,1,.734-.728.117.117,0,0,1,.11.115Z",
  transform: "translate(-1085.558 -59.858)",
  fill: "#fff"
});

function SvgStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_payment",
    "data-name": "icon/payment",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step3.339dbbec.svg";
export { ForwardRef as ReactComponent };